'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

import { serializeJsonLd } from '@/lib/json-ld';

export default function Breadcrumbs() {
  const pathname = usePathname();
  
  // Build breadcrumb items based on current path
  const getBreadcrumbItems = () => {
    const items = [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://votelyquiz.com"
      }
    ];
    
    if (pathname.startsWith('/quiz')) {
      items.push({
        "@type": "ListItem",
        "position": 2,
        "name": "Political Quiz",
        "item": "https://votelyquiz.com/quiz"
      });
      
      if (pathname.includes('/results')) {
        items.push({
          "@type": "ListItem",
          "position": 3,
          "name": "Your Results",
          "item": "https://votelyquiz.com/quiz/results"
        });
      }
    }
    
    return items;
  };
  
  // Content pages render their own BreadcrumbList (components/PageStructuredData),
  // and Google wants at least two items in a list. Everywhere outside /quiz this
  // used to emit a second, one-item list ("Home" alone), so only emit when there
  // is a real trail.
  const items = getBreadcrumbItems();
  if (items.length < 2) return null;

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items
  };
  
  return (
    <Script
      id="breadcrumb-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: serializeJsonLd(breadcrumbSchema)
      }}
    />
  );
}